<div id="containers">
    <ngx-ui-loader [loaderId]="'loader'" [hasProgressBar]="false" [fgsSize]="_fgsSize"
        [fgsType]="SPINNER.wanderingCubes" text="Cargando..."></ngx-ui-loader>
</div>
